import { useMemo, useCallback, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { getZipfileColumns, getZipfileDefaultVisibility } from '../config/zipfileFields.jsx';
import { useUsersData } from '@/shared/hooks/useUsersData';
import { zipfileService } from '../services/zipfileService';

/**
 * Hook for managing zipfile grid columns
 * Now uses pre-calculated values from tree data transformation
 */
export function useZipfileColumns(onEdit) {
  const theme = useTheme();
  const { getUserFullname } = useUsersData();

  // Handle download action
  const handleDownload = useCallback(async (zipfile, event) => {
    event.stopPropagation(); // Prevent row selection
    try {
      await zipfileService.download(zipfile.id_, zipfile.name);
    } catch (err) {
      console.error('Failed to download zipfile:', err);
    }
  }, []);

  // Handle edit action
  const handleEdit = useCallback((zipfile, event) => {
    event.stopPropagation(); // Prevent row selection
    onEdit?.(zipfile);
  }, [onEdit]);

  // Context without selectedZipfile to prevent column recreation on selection
  const context = useMemo(() => ({
    getUserFullname,
    handleDownload,
    handleEdit,
    theme
  }), [getUserFullname, handleDownload, handleEdit, theme]);
  
  // Generate columns using the local zipfile field definitions
  const columns = useMemo(() => {
    return getZipfileColumns(theme, context);
  }, [theme, context]);
  
  // Get initial visibility model
  const [columnVisibilityModel, setColumnVisibilityModel] = useState(() => 
    getZipfileDefaultVisibility(columns)
  );
  
  return {
    columns,
    columnVisibilityModel,
    setColumnVisibilityModel
  };
}